import { render, staticRenderFns } from "./CompanyTrainingRegister.vue?vue&type=template&id=4f136cca&scoped=true"
import script from "./CompanyTrainingRegister.vue?vue&type=script&lang=js"
export * from "./CompanyTrainingRegister.vue?vue&type=script&lang=js"
import style0 from "./CompanyTrainingRegister.vue?vue&type=style&index=0&id=4f136cca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f136cca",
  null
  
)

export default component.exports